import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import Button from "layout/atoms/Button";
import MainContainer from "layout/atoms/MainContainer";
import EmptyState from "layout/molecules/EmptyState";

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("translation");

  useEffect(() => {
    setTimeout(() => {
      navigate("/");
    }, 2000);
  }, []);

  return (
    <MainContainer alignCenter>
      <EmptyState
        type="notFound"
        header={t("emptyStates.notFound.header")}
        subheader={t("emptyStates.notFound.subheader")}
      >
        <Button to="/" color="primary" size="lg">
          {t("emptyStates.notFound.button")}
        </Button>
      </EmptyState>
    </MainContainer>
  );
};

export default NotFound;
